import { Box, Button, Card, CardActions, CardContent, Collapse, Dialog, DialogContent, DialogTitle, Divider, Drawer, Fab, Fade, Hidden, IconButton, List, ListItem, ListItemText, makeStyles, Modal, Paper, Slide, Theme, Tooltip, Typography } from '@material-ui/core';
import { isRemoteLockVehicle } from "../../../../utils/keyless";
import Grid from '@material-ui/core/Grid';
import { createStyles, withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import AspectRatioIcon from '@material-ui/icons/AspectRatio';
import StraightenIcon from '@material-ui/icons/Straighten';
import ScaleIcon from '../../../../assets/icons/scale.svg';
import FilterListIcon from '@material-ui/icons/FilterList';
import { Storage } from "aws-amplify";
import * as _ from "lodash";
import React, { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import { DateTime as d } from "luxon";
import dayjs from "dayjs";
import ReactDOM from "react-dom";
import { useSelector } from "react-redux";
import {
  BookingType,
  IBookingCreateInput,
  IBookingSubscription,
  IBookingVehicleGroup,
  ICamperVanDetails,
  ILocationSurchargeInput,
  ILocationTaxSurcharge,
  IOneWayRentalFee,
  IPriceRule,
  ISubscriptionArgs,
  IVehicleGroupProtectionPlan,
  IVehicleImage,
  IVehicleType,
  VehicleImages,
} from "../../../../reducers/bookings/types";
import { IVehicle } from '../../../../reducers/bookings/types';
import { IRate, IVehiclePriceGroup } from "../../../../reducers/bookings/types";
import { IAppState } from "../../../../store";
import { IFilter, IFilterOption } from "../../../FilterSection/FilterSection";
import { useSnackBar } from "../../../SnackBarContext/SnackBarContext";
import { SnackBarVariant } from "../../../SnackbarWrapper/SnackbarWrapper";
import {
  getFeatureTypeIcon,
  getRetnalTaxAmount,
  getTaxDescription,
  getVehicleGroupApplicableTaxesDetails,
  getVehicleTypeIcon,
  toCurrency
} from "../../../utils";
import { bookingCategories, capitalizeFirstLetter } from "../utils";
import VehicleCounter from "../VehicleCounter";
import styles from './index.module.css'
import InfoIcon from '@material-ui/icons/Info';
import { IBranch } from '../../../../reducers/website/types';
import { SummaryPanel } from '../../../SummaryPanel';
import ImportExportIcon from '@material-ui/icons/ImportExport';
import SelectSubscriptionVehicleView from './SelectSubscriptionVehicleView';
import { RATE_TYPES } from '../../utils';
import Image from '../../../CarouselModule/Image'
import Slider, { Settings } from 'react-slick';
import { FiltersView } from '../../../FiltersView/FiltersView';
import { FiltersBottomSheet } from '../../../FiltersView/FilterBottomSheet';
import { IAddonRate } from '../SelectAddOns/types';
import { getSignedUrl } from '../../../../utils/getSignedUrl';
import { useTranslation } from 'react-i18next';
import { Close } from "@material-ui/icons";
import VehicleDetailDrawerContent from './VehicleDetailDrawer';
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { NuvvenDivider } from '../../Summary/Components/Divider';
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { UserRole } from '../../../../reducers/auth/types';

interface IProps {
  vehicleGroupData: any;
  locationSurcharges: ILocationSurchargeInput[];
  oneWayRentalFee: IOneWayRentalFee | undefined;
  bookingData: IBookingCreateInput;
  values: IBookingCreateInput;
  setValues: Dispatch<SetStateAction<IBookingCreateInput>>
  criteriaData: any;
  bookingType: string;
  subscriptionVehicles?: IVehicle[];
  setSelectedProtectionVehicleGroupPlan: (protectionPlans: IVehicleGroupProtectionPlan[]) => void
}

interface IVehicleSelection extends IVehicle {
  selected: boolean;
}

interface IRenderedVehicleGroup extends IVehiclePriceGroup {
  selectedCount: number;
  vehicles: IVehicleSelection[];
  locationSurcharges?: IPriceRule[];
}

interface InfoDisplayProps {
  items: string[];
  title: string;
  maxVisibleItems: number;
}
interface IFilterData {
  type: string;
  values: string[];
}

const initialFilters = {
  bodyType: '',
  colour: '',
  features: [],
  fuelType: '',
  make: '',
  model: '',
  numberOfDoors: '',
  numberOfSeats: '',
  transmission: '',
  year: ''
};

const settings: Settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  pauseOnHover: true,
  fade: true
};

const AntSwitch = withStyles(() =>
  createStyles({
    root: {
      width: 34,
      height: 22,
      padding: 0,
      display: 'flex',
    },
    switchBase: {
      padding: 4,
      color: "#848484",
      '&$checked': {
        transform: 'translateX(12px)',
        color: "#fff",
        '& + $track': {
          opacity: 1,
          backgroundColor: 'var(--primary-color)',
          borderColor: 'var(--primary-color)',
        },
      },
    },
    thumb: {
      width: 14,
      height: 14,
      boxShadow: 'none',
    },
    track: {
      border: `1px solid rgba(0,0,0,0.8)`,
      borderRadius: 22 / 2,
      height: 22,
      opacity: 1,
      backgroundColor: "#fff",
    },
    checked: {},
  }),
)(Switch);

const StyledSwitch = withStyles((theme) => ({
  switchBase: {
    color: "#d1d5db",
    "&$checked": { color: theme.palette.primary.main },
    "&$checked + $track": { backgroundColor: theme.palette.primary.main },
  },
  checked: {},
  track: {},
}))(Switch);


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    renderVehicleGrid: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      [theme.breakpoints.up('md')]: {
        display: 'block'
      },
    },
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: 'center'
    },
    infoButton: {
      color: "black",
      padding: 0,
      paddingRight: 0,
      marginLeft: 10,
    },
    // Card grid container wrapper (2 columns on sm+)
    groupGridItem: {
      padding: theme.spacing(1),
    },

    // Top row holding image and text
    cardTop: {
      display: "flex",
      gap: 16,
      padding: theme.spacing(2),
      alignItems: "center",
    },

    // image shell - roughly square
    imageShell: {
      flex: "0 0 170px",
      height: 120,
      borderRadius: 10,
      overflow: "hidden",
      background: "#fafafa",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& img": { width: "100%", height: "100%", objectFit: "cover" },
    },

    // main info block
    infoBlock: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      gap: 8,
    },

    groupTitleRow: {
      display: "flex",
      alignItems: "flex-start",
      gap: 8,
      justifyContent: "space-between",
    },

    featuresRow: {
      display: "flex",
      gap: 12,
      flexWrap: "wrap",
      color: "#374151",
      fontSize: 13,
      marginTop: 6,
      justifyContent: "space-between",
    },

    showDetailsBtn: {
      textTransform: "none",
      borderRadius: 8,
      padding: "6px 10px",
    },

    // expanded details container
    detailsWrap: {
      padding: "12px 16px 18px",
      background: "linear-gradient(180deg, #fbfbfc, #f9fafb)",
      borderTop: "1px solid rgba(15,23,42,0.04)",
    },

    // vehicle card inside expanded area
    vehicleDetailCard: {
      display: "flex",
      gap: 12,
      alignItems: "center",
      padding: "10px 12px",
      borderRadius: 10,
      background: "#ffffff",
      boxShadow: "0 6px 18px rgba(2,6,23,0.04)",
      marginBottom: 12,
    },

    vehicleThumb: {
      width: 120,
      height: 78,
      borderRadius: 8,
      overflow: "hidden",
      flex: "0 0 120px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#f6f7f9",
    },

    detailHeader: {
      marginBottom: 6,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      borderBottom: "1px solid #f0f0f0",
      paddingBottom: 6,
      "& .bold": {
        fontWeight: 700,
        fontSize: 14,
        color: "#111827",
      },
    },

    detailInfoGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(3, 1fr)",
      gap: 6,
      fontSize: 13,
      color: "#374151",
    },

    // responsive tweaks
    "@media (max-width: 900px)": {
      imageShell: {
        flex: "0 0 120px",
        height: 92,
      },
      vehicleThumb: {
        width: 92,
        height: 64,
      },
      detailInfoGrid: {
        gridTemplateColumns: "repeat(2, 1fr)",
      },
    },
    modalPaper: {
      borderRadius: 14,
      overflow: "hidden",
    },

    imageShellFull: {
      width: "100%",
      height: 160,
      borderRadius: 12,
      overflow: "hidden",
      background: "#f8f9fb",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& img": { width: "100%", height: "100%", objectFit: "cover" },
    },

    removeButton: {
      background: "transparent",
      border: "1px solid rgba(0,0,0,0.06)",
      borderRadius: 8,
      padding: "6px 10px",
      textTransform: "none",
      "&:hover": { background: "#fff" },
    },

    drawerPaper: {
      width: "100%",
      maxWidth: "100%",
      backgroundColor: "#fff",
      transition: "all 0.5s ease",
      overflow: "hidden",
    },
    drawerHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: theme.spacing(2, 3),
    },
    drawerGroupInfo: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(2),
    },
    drawerGroupImage: {
      width: 54,
      height: 54,
      borderRadius: 6,
      overflow: "hidden",
      "& img": {
        width: "100%",
        height: "100%",
        objectFit: "cover",
      },
    },

    vehicleGridWrapper: {
      padding: theme.spacing(3),
    },
    vehicleCard: {
      borderRadius: 12,
      overflow: "hidden",
      background: "#fff",
      border: "1px solid #e5e7eb",
      transition: "all 0.3s ease",
      cursor: "pointer",
      display: "flex",
      flexDirection: "column",
      height: "100%",
      "&:hover": {
        transform: "translateY(-4px)",
        boxShadow: "0 6px 14px rgba(0,0,0,0.08)",
        borderColor: "#d1d5db",
      },
    },
    vehicleImageWrapper: {
      position: "relative",
      background: "#f9fafb",
      textAlign: "center",
      height: 160,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    cardContent: {
      padding: theme.spacing(2),
      display: "flex",
      justifyContent: "space-between",
      flexDirection: "column",
      flexGrow: 1,
    },
    vehicleTitle: {
      fontSize: 16,
      fontWeight: 600,
      color: "#111827",
      marginBottom: theme.spacing(1),
    },
    specRow: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(3),
    },
    specItem: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(1),
      fontSize: 13,
      color: "#374151",
      "& img": {
        width: 18,
        height: 18,
      },
    },

    splitLayout: {
      display: "flex",
      height: "100%",
      overflow: "hidden",
      flexDirection: "row",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        alignItems: "stretch",
      },
    },

    leftNav: {
      display: "flex",
      flexDirection: "column",
      width: "15%",
      borderRight: "1px solid #e5e7eb",
      overflowY: "auto",
      background: "#f9fafb",
      padding: theme.spacing(2),
      transition: "all 0.4s ease",
      "&::-webkit-scrollbar": { width: 6 },
      "&::-webkit-scrollbar-thumb": {
        borderRadius: 4,
        background: "#d1d5db",
      },

      [theme.breakpoints.down("sm")]: {
        width: "100%",
        borderRight: "none",
        borderBottom: "1px solid #e5e7eb",
        display: "flex",
        flexDirection: "row",
        overflowX: "auto",
        overflowY: "hidden",
        padding: theme.spacing(1.25, 1),
        gap: theme.spacing(1.25),

        // horizontal scrollbar styling
        "&::-webkit-scrollbar": { height: 0 },
        "&::-webkit-scrollbar-thumb": {
          borderRadius: 0,
          background: "transparent",
        },
        backdropFilter: "blur(6px)",
      },
    },

    leftVehicleCard: {
      display: "flex",
      flexDirection: "column",
      borderRadius: 10,
      border: "1px solid transparent",
      background: "#fff",
      marginBottom: theme.spacing(2),
      transition: "all 0.25s ease",
      cursor: "pointer",
      "&:hover": {
        transform: "translateY(-3px)",
        borderColor: "#d1d5db",
        boxShadow: "0 3px 10px rgba(0,0,0,0.05)",
      },

      // mobile: horizontal compact chip
      [theme.breakpoints.down("sm")]: {
        flexDirection: "row",
        alignItems: "center",
        marginBottom: 0,
        padding: theme.spacing(1),
        border: "1px solid #eef2f8",
        borderRadius: 6,
      },
    },

    leftVehicleActive: {
      borderColor: "#2563eb !important",
      background: "#eff6ff",
      boxShadow: "0 0 12px rgba(37,99,235,0.18)",
      transform: "translateY(-3px)",
    },

    leftVehicleImage: {
      background: "#f3f4f6",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderTopLeftRadius: 10,
      borderTopRightRadius: 10,
      "& img": {
        width: "100%",
        height: "auto",
        objectFit: "contain",
        maxWidth: "170px",
      },

      // mobile chip image: compact square
      [theme.breakpoints.down("sm")]: {
        flex: "0 0 56px",
        width: 56,
        height: 40,
        borderRadius: 8,
        "& img": { width: "100%", height: "100%", objectFit: "contain" },
      },
    },

    leftVehicleInfo: {
      padding: theme.spacing(1.2, 1.5),
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },

    /* Floating scroll button (visible on mobile) */
    scrollButton: {
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      zIndex: 20,
      width: 36,
      height: 36,
      borderRadius: "50%",
      background: "rgba(255,255,255,0.95)",
      backdropFilter: "blur(6px)",
      boxShadow: "0 6px 18px rgba(2,6,23,0.12)",
      display: "none", // default hidden on desktop
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
      transition: "all 0.18s ease",

      // show on mobile and tablet small screens
      [theme.breakpoints.down("md")]: {
        display: "flex",
      },

      "&:hover": {
        transform: "translateY(-50%) scale(1.06)",
      },
    },

    scrollButtonLeft: {
      left: 8,
    },
    scrollButtonRight: {
      right: 8,
    },

    rightDetailPane: {
      width: "70%",
      flexGrow: 1,
      overflowY: "auto",
      backgroundColor: "#fff",
      transition: "all 0.4s ease",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      }
    },

    vehicleGroupCardPremium: {
      borderRadius: 6,
      background: "#ffffff",
      border: "1px solid #d7d8d8",
      overflow: "hidden",
      transition: "transform 280ms cubic-bezier(.22,.61,.36,1), box-shadow 280ms",
      boxShadow: "0 6px 20px rgba(16,24,40,0.04)",
      "&:hover": {
        transform: "translateY(-4px)",
        boxShadow: "0 12px 36px rgba(16,24,40,0.08)",
      },
    },

    cardTopVertical: {
      display: "flex",
      flexDirection: "column",
      minHeight: 1,
    },

    /* Image area */
    imageContainerFix: {
      width: "100%",
      height: 150,
      padding: 10,
      textAlign: "center",
      overflow: "hidden",
      "& img": {
        width: "100%",
        maxWidth: "250px",
        objectFit: "contain",
        transition: "transform 420ms ease, filter 420ms ease",
      },
      "&:hover img": {
        transform: "scale(1.03)",
      },
    },

    sliderItem: {
      outline: "none",
    },

    noImage: {
      width: "100%",
      maxWidth: "250px",
      objectFit: "contain",
      background: "#fafbfc",
    },

    infoBlockVertical: {
      padding: theme.spacing(1, 1.5),
      display: "flex",
      flexDirection: "column",
      gap: 8,
    },

    titleRow: {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      gap: 8,
      marginTop: 5,
      [theme.breakpoints.between(600, 1299)]: {
        display: "block",
      },
      [theme.breakpoints.between(320, 450)]: {
        display: "block",
      }
    },

    titleLeft: {
      minWidth: 0,
      flex: 1,
    },

    titleRight: {
      display: "flex",
      alignItems: "center",
      marginLeft: theme.spacing(1),
    },

    groupTitle: {
      fontSize: 18,
      fontWeight: 700,
      color: "#111827",
      lineHeight: 1.15,
      marginBottom: 2,
      whiteSpace: "normal",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },

    metaRow: {
      marginTop: 6,
      display: "flex",
      alignItems: "center",
      gap: 8,
    },

    tag: {
      display: "inline-flex",
      alignItems: "center",
      gap: 8,
      background: "linear-gradient(180deg,#ffffff,#fbfdff)",
      border: "1px solid #eef3ff",
      padding: "4px 8px",
      borderRadius: 14,
      fontSize: 12,
      color: "#3751a3",
      boxShadow: "inset 0 -1px 0 rgba(57,84,160,0.02)",
      [theme.breakpoints.down("xs")]: {
        gap: 4,
        fontSize: 10,
        padding: "2px 6px",
      },
      [theme.breakpoints.between(600, 759)]: {
        gap: 4,
        fontSize: 10,
        padding: "2px 4px",
      },
    },

    tagDot: {
      width: 8,
      height: 8,
      borderRadius: "50%",
      background: "#3b82f6",
      display: "inline-block",
    },

    infoBtn: {
      padding: 6,
      color: "#6b7280",
      "&:hover": { backgroundColor: "transparent", color: "#374151" },
      [theme.breakpoints.down("xs")]: {
        padding: 3,
      }
    },

    priceAndBadgesRow: {
      display: "flex",
      alignItems: "center",
      gap: 8,
      flexWrap: "wrap",
      [theme.breakpoints.down("xs")]: {
        gap: 4,
      }
    },

    taxLabel: {
      fontSize: 12,
      color: "#6b7280",
      marginLeft: 6,
      [theme.breakpoints.down("xs")]: {
        marginLeft: 3,
      }
    },

    featureIcon: {
      height: 20,
      width: 20,
      cursor: "pointer",
      display: "inline-block",
    },

    specPill: {
      background: "#f7f9fb",
      border: "1px solid #eef2f8",
      padding: "4px 8px",
      borderRadius: 6,
      fontSize: 12,
      color: "#111827",
      display: "inline-flex",
      alignItems: "center",
      minHeight: 28,
    },

    /* actions */
    actionsRow: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginTop: 8,
      marginBottom: 6,
    },

    counterWrap: {
      display: "flex",
      alignItems: "center",
    },

    actionRight: {
      display: "flex",
      alignItems: "center",
      gap: 8,
    },

    viewIconBtn: {
      color: "#1a3e8a",
      background: "#eef3ff",
      width: 38,
      height: 38,
      borderRadius: 10,
      padding: 6,
      transition: "all 200ms ease",
      "&:hover": {
        background: "#d9e7ff",
        boxShadow: "0 6px 16px rgba(26,62,138,0.18)",
      },
    },

    iconMain: {
      fontSize: 26,
    },

    iconOverlay: {
      position: "absolute",
      bottom: -2,
      right: -4,
      fontSize: 14,
      opacity: 0.95,
    },
    arrowIcon: {
      fontSize: 18,
      marginLeft: 1,
      [theme.breakpoints.between(600, 759)]: {
        fontSize: 14,
      }
    },
  })
);

const PremiumTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#fff !important',
    color: '#333',
    maxWidth: 320,
    borderRadius: 12,
    padding: '12px 16px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    border: '1px solid #e0e0e0',
    fontSize: 13,
    lineHeight: 1.6,
  },
  arrow: {
    color: '#fff',
  },
}))(Tooltip);

const InfoDisplay: React.FC<InfoDisplayProps> = ({
  items,
  title,
  maxVisibleItems = 2
}) => (
  <>
    <span style={{ position: "relative" }}>
      {items.slice(0, maxVisibleItems).join(", ")}
    </span>
    {items.length > maxVisibleItems && (
      <span>
        <IconButton
          style={{
            color: "black",
            padding: 0,
            paddingRight: 5,
            marginLeft: 5
          }}
        >
          <PremiumTooltip
            title={
              <>
                {
                  <Box>
                    <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 4 }}>
                      {title}
                    </Typography>
                    <Divider style={{ marginBottom: 8 }} />
                    {items.map((item) => (
                      <Typography variant='h5' key={item}>{item}</Typography>
                    ))}
                  </Box>
                }
              </>
            }
            // arrow
            // interactive
            placement="right"
          >
            <InfoIcon />
          </PremiumTooltip>
        </IconButton>
      </span>
    )}
  </>
);

const VehicleSelection: React.FC<IProps> = (props) => {

  let price = 0;
  let rentalPrice = 0;
  const snackbar = useSnackBar();
  const locationSurchargeData: ILocationTaxSurcharge[] = [];
  const branchData = useSelector((state: IAppState) => state.consumerWebsiteReducer.consumerWebsite.branches);
  const organisation = useSelector((state: IAppState) => state.consumerWebsiteReducer.consumerWebsite.organisation);
  const hideFilters = useSelector((state: IAppState) => state.consumerWebsiteReducer.consumerWebsite.hideFilters);
  const { locale, currency } = organisation;
  const { country } = organisation.address;
  const [selectedVehicleGroup, setSelectedVehicleGroup] = useState<string | undefined>();
  const [renderedVehicleGroups, setRenderedVehicleGroups] = useState<IRenderedVehicleGroup[]>([]);
  const [filteredVehicleGroups, setFilteredVehicleGroups] = useState<IVehiclePriceGroup[]>([]);
  const [vehicleGroupsImage, setVehicleGroupsImage] = useState<any[]>([]);
  const [filters, setFilters] = useState<IFilter[]>([]);
  const [searchFilters, setSearchFilters] = useState<any>(initialFilters);
  const [smartCarOnly, setSmartCarOnly] = useState<boolean>(props.bookingData.isKeylessEntry || false);
  const [hasSmartCar, setHasSmartCar] = useState<boolean>();
  const [showSmartCarFilter, setShowSmartCarFilter] = useState<boolean>(true);
  const [currentBranch, setCurrentBranch] = useState<IBranch>();
  const [fleetType, setFleetType] = useState<string>("");
  const [sortOrder, setSortOrder] = useState(0)
  const [bookingDurationInWeeks, setBookingDurationInWeeks] = useState<number>(0);
  const [bookingDurationInMonths, setBookingDurationInMonths] = useState<number>(0);
  const [bookingDurationInHours, setBookingDurationInHours] = useState<number>(0);
  const [bookingDurationInDays, setBookingDurationInDays] = useState<number>(0);
  const [activeSubscriptionData, setActiveSubscriptionData] = useState<Partial<IBookingSubscription>>()
  const { t } = useTranslation();
  const [selectedImageIndex, setSelectedImageIndex] = useState<number | null>(null);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [vehicleImages, setVehicleImages] = useState<VehicleImages[]>([]);
  const [renderedSubscriptionVehicles, setRenderedSubscriptionVehicles] = useState<IVehicle[]>([]);
  const [openFilterBottomSheet, setOpenFilterBottomSheet] = useState<boolean>(false)
  const [expandedGroupId, setExpandedGroupId] = useState<string | null>(null);
  const [openGroup, setOpenGroup] = useState<IRenderedVehicleGroup | null>(null);
  const [vehicleDetailDrawerOpen, setVehicleDetailDrawerOpen] = useState<boolean>(false);
  const [mode, setMode] = useState<"grid" | "split">("split");
  const [selectedVehicle, setSelectedVehicle] = useState<IVehicle | null>(null);
  const [allVehicleImages, setAllVehicleImages] = useState<IVehicleImage[]>([]);
  const [totalPrice, setTotalPrice] = useState<string>("");
  const scrollerRef = useRef<HTMLDivElement | null>(null);

  const handleCardClick = (e: any, vehicle: IVehicle) => {
    if (e.target.closest(".switch-zone")) return;
    setSelectedVehicle(vehicle);
    setMode("split");
  };

  const isTestDrive = props.bookingType === BookingType.TEST_DRIVE;
  const website = useSelector((state: IAppState) => state.consumerWebsiteReducer.consumerWebsite);
  const authUser = useSelector((state: IAppState) => state.authReducer.user);
  const isBusinessCustomer = authUser && authUser.businesscustomers;
  const { vehicleDetailsSettings } = website;
  const multipleVehicleBooking = !isBusinessCustomer ? (website.multipleVehicleBooking || false) : true;
  let showVehicleGroupPrices = true;
  const bookingCategorySettings = bookingCategories[props.bookingType as BookingType];
  const classes = useStyles();
  if (isTestDrive) {
    showVehicleGroupPrices = false;
  } else if (organisation.closeGroupSharingEnabled) {
    showVehicleGroupPrices = false;
  }

  const { values, setValues } = props;
  if (props.locationSurcharges && props.locationSurcharges.length) {
    props.locationSurcharges.forEach((surcharge: ILocationSurchargeInput) => {
      locationSurchargeData.push({
        id: surcharge.id || "",
        name: surcharge.title,
        value: surcharge.value,
        rate: surcharge.rate,
        type: surcharge.type || "FIXED",
        tax: {
          title: surcharge.taxable && surcharge.tax && surcharge.tax.title ? surcharge.tax.title : "",
          value: surcharge.taxable && surcharge.tax && surcharge.tax.value ? surcharge.tax.value : 0
        }
      });
    })
  }

  useEffect(() => {
    if (props.values && props.values.pickupDateTime) {
      const pickupDt = d.fromISO(props.values.pickupDateTime);
      const dropoffDt = d.fromISO(props.values.dropoffDateTime || "");
      setBookingDurationInMonths(dropoffDt.diff(pickupDt, ["months"]).months);
      setBookingDurationInWeeks(dropoffDt.diff(pickupDt, ["weeks"]).weeks);
      setBookingDurationInHours(dropoffDt.diff(pickupDt, "hours").hours);
      setBookingDurationInDays(dropoffDt.diff(pickupDt, "days").days);
    }
  }, [props.values])

  useEffect(() => {
    if (props.criteriaData) {
      let filtersArr: IFilter[] = [...props.criteriaData];
      if (organisation.hideYearFilter) {
        filtersArr = filtersArr.filter((filter) => filter.id !== "year");
      }
      setFilters(filtersArr);
    }
  }, [props.criteriaData]);

  useEffect(() => {
    if (props.subscriptionVehicles && props.subscriptionVehicles.length) {
      setRenderedSubscriptionVehicles(props.subscriptionVehicles)
      if (props.bookingData.activeSubscription) {
        const filterOldSubscriptionVehicle = props.subscriptionVehicles.find(vehicle => vehicle.id === props.bookingData.activeSubscription.vehicle)
        if (props.values?.activeSubscriptionExpanded && filterOldSubscriptionVehicle) {
          setActiveSubscriptionData({
            ...props.values?.activeSubscriptionExpanded,
            startDate: props.values.pickupDateTime,
            endDate: props.bookingData.dropoffDateTime
          })
        } else {
          setActiveSubscriptionData({})
          const { activeSubscription, activeSubscriptionExpanded, ...rest } = props.values
          setValues(rest)
        }
      }
    }

  }, [props.subscriptionVehicles])

  useEffect(() => {
    const selectedBranch = branchData.find((branch) => branch.id === values.branchId);
    selectedBranch && setCurrentBranch(selectedBranch)
  }, [values.branchId])

  function mergeSharedVehiclesToOwn(vehicleGroups: IVehiclePriceGroup[]) {
    const mergedGroups: IVehiclePriceGroup[] = [];
    vehicleGroups.forEach((group) => {
      const existingIndex = mergedGroups.findIndex((mergedGroup) => mergedGroup.id === group.id);
      if (existingIndex === -1) {
        mergedGroups.push({ ...group, vehicles: [...group.vehicles] });
      } else {
        mergedGroups[existingIndex].vehicles.push(...group.vehicles);
      }
    });

    return mergedGroups;
  }

  useEffect(() => {
    if (props.bookingType !== BookingType.SUBSCRIPTION) {
      let hasNonSmartCar = false;
      const vehicleGroupsArr = JSON.parse(JSON.stringify(props.vehicleGroupData));
      const updatedArr = mergeSharedVehiclesToOwn(vehicleGroupsArr)
      getVehicleGroupImage(updatedArr);
      const filteredVehicleGroupArr: IVehiclePriceGroup[] = [];
      // tslint:disable-next-line: prefer-for-of
      for (let index = 0; index < updatedArr.length; index++) {
        const element = updatedArr[index];
        const availableVehicles = [];
        const ghostVehicles = [];
        // tslint:disable-next-line: prefer-for-of
        for (let j = 0; j < element.vehicles.length; j++) {
          const vehicle: any = element.vehicles[j];
          let available = true;
          // tslint:disable-next-line: prefer-for-of
          for (let k = 0; k < Object.keys(searchFilters).length; k++) {
            if (searchFilters[Object.keys(searchFilters)[k]].length) {

              if (!vehicle.hasOwnProperty(Object.keys(searchFilters)[k])) {
                available = false;
                break;
              }
              if (["year", "numberOfDoors", "numberOfSeats"].includes(Object.keys(searchFilters)[k])) {
                const filtersArr = searchFilters[Object.keys(searchFilters)[k]].map((item: string) => parseInt(item));
                if (!filtersArr.includes(vehicle[Object.keys(searchFilters)[k]])) {
                  available = false;
                  break;
                }
              } else if (Object.keys(searchFilters)[k] === "features") {
                let flag = true;
                if (vehicle[Object.keys(searchFilters)[k]].length) {
                  vehicle[Object.keys(searchFilters)[k]].forEach((item: string) => {
                    if (searchFilters[Object.keys(searchFilters)[k].toLowerCase()].includes(item.toLowerCase())) {
                      flag = false;
                    }
                  });
                }
                if (flag) {
                  available = false;
                  break;
                }
              } else {
                if (!searchFilters[Object.keys(searchFilters)[k]].includes(
                  vehicle[Object.keys(searchFilters)[k]].toLowerCase())) {
                  available = false;
                  break;
                }
              }
            }
          }
          if (isRemoteLockVehicle(vehicle) && !hasSmartCar) {
            setHasSmartCar(true);
          }
          if (!hasNonSmartCar && !isRemoteLockVehicle(vehicle)) {
            hasNonSmartCar = true;
          }
          // if (smartCarOnly && !vehicle.smartCarVehicleID) {
          //   available = false
          // }
          if (available) {
            const selectedBranch = branchData.find((branch) => branch.id === values.branchId);
            if (selectedBranch?.overbookingAllowed) {
              if (vehicle.isGhostVehicle) {
                ghostVehicles.push(vehicle);
              } else {
                availableVehicles.push(vehicle);
              }
            }
            else {
              if (!vehicle.isGhostVehicle) {
                availableVehicles.push(vehicle)
              }
            }
          }
        }
        element.vehicles = [...availableVehicles, ...ghostVehicles];
        if (element.vehicles.length > 0) {
          filteredVehicleGroupArr.push(element);
        }
      }
      filteredVehicleGroupArr.sort((vg1, vg2) => {
        const vg1BasePrice = vg1.basePrices.find((price: IRate) => price.rateTypeName === values.rateTypeName)
        const vg2BasePrice = vg2.basePrices.find((price: IRate) => price.rateTypeName === values.rateTypeName)
        let vg1price = 0;
        let vg2price = 0;
        if (vg1BasePrice?.applicableAmount) {
          vg1price = vg1BasePrice.applicableAmount;
        } else if (vg1BasePrice?.rate) {
          vg1price = vg1BasePrice.rate;
        }
        if (vg2BasePrice?.applicableAmount) {
          vg2price = vg2BasePrice.applicableAmount;
        } else if (vg2BasePrice?.rate) {
          vg2price = vg2BasePrice.rate;
        }
        return sortOrder ? vg2price - vg1price : vg1price - vg2price;
      });
      setFilteredVehicleGroups(filteredVehicleGroupArr);
      if (!hasNonSmartCar) {
        setShowSmartCarFilter(false);
        setSmartCarOnly(true);
      }
    } else {
      const availableVehicles = [];
      // tslint:disable-next-line: prefer-for-of
      const vehicles = JSON.parse(JSON.stringify(props.subscriptionVehicles))
      for (let i = 0; i < vehicles.length; i++) {
        const vehicle: any = vehicles[i];
        let available = true;
        // tslint:disable-next-line: prefer-for-of
        for (let k = 0; k < Object.keys(searchFilters).length; k++) {
          if (searchFilters[Object.keys(searchFilters)[k]].length) {
            setValues({
              ...values,
              vehicleGroups: []
            })
            if (!vehicle.hasOwnProperty(Object.keys(searchFilters)[k])) {
              available = false;
              break;
            }
            if (["year", "numberOfDoors", "numberOfSeats"].includes(Object.keys(searchFilters)[k])) {
              const filtersArr = searchFilters[Object.keys(searchFilters)[k]].map((item: string) => parseInt(item));
              if (!filtersArr.includes(vehicle[Object.keys(searchFilters)[k]])) {
                available = false;
                break;
              }
            } else if (Object.keys(searchFilters)[k] === "features") {
              let flag = true;
              if (vehicle[Object.keys(searchFilters)[k]].length) {
                vehicle[Object.keys(searchFilters)[k]].forEach((item: string) => {
                  if (searchFilters[Object.keys(searchFilters)[k].toLowerCase()].includes(item.toLowerCase())) {
                    flag = false;
                  }
                });
              }
              if (flag) {
                available = false;
                break;
              }
            } else {
              if (!searchFilters[Object.keys(searchFilters)[k]].includes(
                vehicle[Object.keys(searchFilters)[k]].toLowerCase())) {
                available = false;
                break;
              }
            }
          }
        }
        if (available) {
          availableVehicles.push(vehicle)
        }
      }
      setRenderedSubscriptionVehicles(availableVehicles)
    }
  }, [searchFilters, smartCarOnly, sortOrder, props.subscriptionVehicles]);

  useEffect(() => {
    if (hasSmartCar) {
      setValues({
        ...values,
        vehicleGroups: [],
        smartCarVehicle: false
      })
    }
  }, [smartCarOnly])

  useEffect(() => {
    let bookingVehicleGroups = [...props.values.vehicleGroups];
    let tempGroupArray: IRenderedVehicleGroup[] = []
    tempGroupArray = filteredVehicleGroups.length ? filteredVehicleGroups.map((vg) => {
      let selectedCount: number = 0;
      let tempVehicles: IVehicleSelection[] = vg.vehicles.map((vehicle) => {
        return {
          ...vehicle,
          selected: false
        }
      });
      if (bookingVehicleGroups.length) {
        bookingVehicleGroups.map((bookingVg) => {
          if (bookingVg.vehicleGroup === vg.id) {
            bookingVg.vehicleIds.map((vehicleId) => {
              const vehicleIndex = tempVehicles.findIndex(item => item.id === vehicleId)
              if (vehicleIndex >= 0) {
                selectedCount += 1;
                tempVehicles[vehicleIndex].selected = true;
              }
            })
          }
          else {
            bookingVg.vehicleIds.map((vehicleId) => {
              const vehicleIndex = tempVehicles.findIndex(item => item.id === vehicleId)
              if (vehicleIndex >= 0) {
                tempVehicles.splice(vehicleIndex, 1);
              }
            })
          }
        })
      }
      const vehicleGroup = bookingVehicleGroups.find(bvg => bvg.vehicleGroup === vg.id);
      if (vehicleGroup && vehicleGroup.count) {
        selectedCount = vehicleGroup.count
      }
      return {
        ...vg,
        selectedCount,
        vehicles: tempVehicles
      }
    }) : []
    setRenderedVehicleGroups(tempGroupArray);
  }, [filteredVehicleGroups])

  const getDoorString = (item: IVehiclePriceGroup) => {
    const doorSet = new Set();
    item.vehicles.forEach((vehicle: IVehicle) => {
      doorSet.add(vehicle.numberOfDoors);
    });
    let outputArr = Array.from(doorSet);
    outputArr = outputArr.filter((item: any) => item > 0).sort();
    return (
      <span className="flex cross-center">
        <img
          style={{ height: "12px", width: "12px", marginRight: "5px" }}
          src={getFeatureTypeIcon("numberOfDoors")}
          alt={t("root:numberOfDoors")}
        />
        <span style={{ position: "relative" }}>
          {outputArr.join(",")}
        </span>
      </span>
    );
  };

  const getSeatString = (item: IVehiclePriceGroup) => {
    const seatSet = new Set();
    item.vehicles.forEach((vehicle: IVehicle) => {
      seatSet.add(vehicle.numberOfSeats);
    });
    let outputArr = Array.from(seatSet);
    outputArr = outputArr.filter((item: any) => item > 0).sort();
    return (
      <span className="flex cross-center">
        <img
          style={{ height: "12px", width: "12px", marginRight: "5px" }}
          src={getFeatureTypeIcon("numberOfSeats")}
          alt={t("root:numberOfSeats")}
        />
        <span style={{ position: "relative" }}>
          {outputArr.join(",")}
        </span>
      </span>
    );
  };

  const getTransmissionString = (item: IVehiclePriceGroup) => {
    const transmmissionSet = new Set();
    item.vehicles.forEach((vehicle: IVehicle) => {
      transmmissionSet.add(vehicle.transmission.charAt(0).toUpperCase() + vehicle.transmission.slice(1).toLowerCase());
    });
    let outputArr: any[] = Array.from(transmmissionSet);
    outputArr = outputArr.map(item => item.slice(0, 1))
    return (
      <span className="flex cross-center">
        <img
          style={{ height: "12px", width: "12px", marginRight: "5px" }}
          src={getFeatureTypeIcon("transmission")}
          alt={t("root:transmission")}
        />
        <span style={{ position: "relative" }}>
          {outputArr.join(",")}
        </span>
      </span>
    );
  };

  const getFuelTypeString = (item: IVehiclePriceGroup) => {
    const fuelSet: Set<string> = new Set();
    item.vehicles.forEach((vehicle: IVehicle) => {
      fuelSet.add(vehicle?.fuelType?.charAt(0).toUpperCase());
    });
    const outputArr: string[] = Array.from(fuelSet);
    return (
      <span className="flex cross-center">
        <img
          style={{ height: "12px", width: "12px", marginRight: "5px" }}
          src={getFeatureTypeIcon("fuelType")}
          alt={"fuelType"}
        />
        <InfoDisplay items={outputArr} maxVisibleItems={2} title="Fuel Type" />
      </span>
    );
  };

  const getTrailerInternalDimensions = (item: IVehiclePriceGroup) => {
    const internalDimensionSet = new Set();
    item.vehicles.forEach((vehicle: IVehicle) => {
      internalDimensionSet.add(`${vehicle.internalPlatformLength || 0}m x ${vehicle.internalPlatformWidth || 0}m x ${vehicle.internalHeight || 0}m`)
    })
    const outputArr = Array.from(internalDimensionSet).filter(item => item != "0m x 0m x 0m")
    return (
      outputArr.length ?
        <span>
          <StraightenIcon style={{
            height: "12px",
            marginRight: "5px",
            width: "12px",
          }} />
          <Tooltip title={
            <React.Fragment>
              <Typography color="inherit">Internal Dimensions</Typography>
              <ul style={{
                paddingLeft: 7,
                marginLeft: 7,
                marginTop: 4
              }}>
                {outputArr.map(item => (<li>{item}</li>))}
              </ul>
            </React.Fragment>
          }>
            <InfoIcon style={{
              height: "12px",
              marginRight: "5px",
              width: "12px",
            }} />
          </Tooltip>
        </span> : <></>
    )
  }
  const getTrailerExternalDimensions = (item: IVehiclePriceGroup) => {
    const internalDimensionSet = new Set();
    item.vehicles.forEach((vehicle: IVehicle) => {
      internalDimensionSet.add(`${vehicle.externalPlatformLength || 0}m x ${vehicle.externalPlatformWidth || 0}m x ${vehicle.externalPlatformHeight || 0}m`)
    })
    const outputArr = Array.from(internalDimensionSet).filter(item => item != "0m x 0m x 0m")
    return (
      outputArr.length ?
        <span>
          <AspectRatioIcon style={{
            height: "12px",
            marginRight: "5px",
            width: "12px",
          }} />
          <Tooltip title={
            <React.Fragment>
              <Typography color="inherit">External Dimensions</Typography>
              <ul style={{
                paddingLeft: 7,
                marginLeft: 7,
                marginTop: 4
              }}>
                {outputArr.map(item => (<li>{item}</li>))}
              </ul>
            </React.Fragment>
          }>
            <InfoIcon style={{
              height: "12px",
              marginRight: "5px",
              width: "12px",
            }} />
          </Tooltip>
        </span> : <></>
    )
  }
  const getTrailerWeight = (item: IVehiclePriceGroup) => {
    const internalDimensionSet = new Set();
    item.vehicles.forEach((vehicle: IVehicle) => {
      internalDimensionSet.add(`${vehicle.trailerWeight || 0}kg`)
    })
    const outputArr = Array.from(internalDimensionSet).filter(item => item != "0kg")
    return (
      outputArr.length ?
        <span>
          <img src={ScaleIcon} style={{
            height: "12px",
            marginRight: "5px",
            width: "12px",
          }} />
          <Tooltip title={
            <React.Fragment>
              <Typography color="inherit">Weight</Typography>
              <ul style={{
                paddingLeft: 7,
                marginLeft: 7,
                marginTop: 4
              }}>
                {outputArr.map(item => (<li>{item}</li>))}
              </ul>
            </React.Fragment>
          }>
            <InfoIcon style={{
              height: "12px",
              marginRight: "5px",
              width: "12px",
            }} />
          </Tooltip>
        </span> : <></>
    )
  }


  const renderRatyeTypeName = (rateType: string) => {
    if (rateType === "weekly") {
      return `/${t("root:week")}`
    } else if (rateType === "daily") {
      return `/${t("root:day")}`
    } else if (rateType === "hourly") {
      return `/${t("root:hour")}`
    } else {
      return `/${t("root:month")}`
    }
  }

  const renderGroupBasePrice = (item: IRenderedVehicleGroup, setPriceOnly?: boolean) => {
    const basePrice = item.basePrices.find((price: IRate) => price.rateTypeName === values.rateTypeName);
    let onDiscount = true;
    let totalSurcharge = 0;
    if (basePrice) {
      if (basePrice.applicableAmount) {
        price = basePrice.applicableAmount;
        rentalPrice = basePrice.applicableAmount;
      } else {
        price = basePrice.rate;
        rentalPrice = basePrice.rate;
      }
      if (price > basePrice.rate) {
        onDiscount = false;
      }
      let taxAmount = 0;
      const applicableTaxes = getVehicleGroupApplicableTaxesDetails(taxes as any, item && item.id ? item.id : "");
      const taxTitles = getTaxDescription(applicableTaxes, currency, locale);
      const rentalTaxAmount = getRetnalTaxAmount(authUser?.customer?.taxExempted ? [] : applicableTaxes, price, 1, 1);
      taxAmount = rentalTaxAmount;

      const finalPrice = price + taxAmount;
      if (setPriceOnly) {
        const updatedPrice =
          `${website.vatInclusivePricingEnabled ? toCurrency(finalPrice, currency, locale) : toCurrency(price, currency, locale)}${!organisation.closeGroupSharingEnabled ? renderRatyeTypeName(basePrice.rateTypeName) : ""}`;
        setTotalPrice(updatedPrice);
      } else {
        return (
          <>
            {(!basePrice.applicableAmount && !totalSurcharge) ?
              (
                <>
                  <Hidden smDown>
                    <span className="flex fill"></span>
                  </Hidden>
                  <div className='flex cross-end'>
                    <span className={styles.currentPrice} style={{ fontSize: "28px", fontWeight: 700 }}>
                      {website.vatInclusivePricingEnabled ? toCurrency(finalPrice, currency, locale) : toCurrency(price, currency, locale)}
                      {!organisation.closeGroupSharingEnabled ? <span className={styles.priceName}>{renderRatyeTypeName(basePrice.rateTypeName)}</span> : ""}
                    </span>
                  </div>
                </>
              )
              :
              (
                <>
                  <Hidden smDown>
                    <span className="flex fill"></span>
                  </Hidden>
                  <div className='flex cross-end'>
                    <span className={styles.currentPrice} style={{ fontSize: "28px", fontWeight: 700 }}>
                      {website.vatInclusivePricingEnabled ? toCurrency(finalPrice, currency, locale) : toCurrency(price, currency, locale)}
                      {!organisation.closeGroupSharingEnabled ? <span className={styles.priceName}>{renderRatyeTypeName(basePrice.rateTypeName)}</span> : ""}
                    </span>
                  </div>
                </>
              )}
          </>
        )
      }
    }
  };

  const renderTaxPrice = (item: IRenderedVehicleGroup): number => {
    const basePrice = item.basePrices.find((price: IRate) => price.rateTypeName === values.rateTypeName);
    if (!basePrice) return 0;
    const applicableAmount = basePrice.applicableAmount ?? basePrice.rate;
    const applicableTaxes = getVehicleGroupApplicableTaxesDetails(taxes as any, item?.id ?? "");
    const taxAmount = getRetnalTaxAmount(authUser?.customer?.taxExempted ? [] : applicableTaxes, applicableAmount, 1, 1);
    return taxAmount;
  };

  const getVehicleGroupImage = (vehicleGroupsList: IVehiclePriceGroup[]) => {
    vehicleGroupsList.map(async (vehicleGroup: any) => {
      try {
        const config = { contentType: "image/*", level: "public" };

        // 1️ Vehicle Group Images

        if (vehicleGroup?.images?.length) {
          const groupImageUrls: IVehicleImage[] = await Promise.all(
            vehicleGroup.images.map(async (image: any) => {
              const url = image?.url ? await getSignedUrl(image.url) : "";
              return {
                idx: image?.idx,
                url,
                key: image?.url,
                default: image?.default,
              };
            })
          );

          const sortedGroupImages = groupImageUrls.sort((a, b) => Number(b.default) - Number(a.default));

          setVehicleGroupsImage((prev: any[]) => [
            ...prev,
            {
              vehicleGroupId: vehicleGroup.id,
              images: sortedGroupImages,
            },
          ]);
        } else if (vehicleGroup?.imageUrl) {
          // Fallback → use vehicleGroup.imageUrl if no uploaded group images
          const fallbackUrl = await getSignedUrl(vehicleGroup.imageUrl);
          setVehicleGroupsImage((prev: any[]) => [
            ...prev,
            {
              vehicleGroupId: vehicleGroup.id,
              images: [
                {
                  idx: 0,
                  url: fallbackUrl,
                  key: vehicleGroup.imageUrl,
                  default: true,
                },
              ],
            },
          ]);
        }

        // 2️ Vehicle Images 

        if (vehicleGroup?.vehicles?.length) {
          for (const vehicle of vehicleGroup.vehicles) {
            let sortedVehicleImages: IVehicleImage[] = [];

            // If vehicle.images exist → use them
            if (vehicle?.images?.length) {
              const vehicleImageUrls: IVehicleImage[] = await Promise.all(
                vehicle.images.map(async (image: any) => {
                  const url = image?.url ? await getSignedUrl(image.url) : "";
                  return {
                    idx: image?.idx,
                    url,
                    default: image?.default,
                    vehicleId: vehicle.id,
                    groupId: vehicleGroup.id,
                  };
                })
              );

              sortedVehicleImages = vehicleImageUrls.sort(
                (a, b) => Number(b.default) - Number(a.default)
              );
            }

            // Fallback → use vehicle.imageUrl if no uploaded images
            if (sortedVehicleImages.length === 0 && vehicle?.imageUrl) {
              const fallbackUrl = await getSignedUrl(vehicle.imageUrl);
              sortedVehicleImages = [
                {
                  idx: 0,
                  url: fallbackUrl,
                  default: true,
                  vehicleId: vehicle.id,
                  groupId: vehicleGroup.id,
                },
              ];
            }

            // Save images (either uploaded or fallback)
            if (sortedVehicleImages.length > 0) {
              setAllVehicleImages((prev: any[]) => [...prev, ...sortedVehicleImages]);
            }
          }
        }

      } catch (error) {
        snackbar({
          message: t("snackBar:invalidFileType"),
          variant: SnackBarVariant.ERROR
        });
      }
    });
  };

  const retriedGroupImagesRef = useRef<Set<string>>(new Set());

  const handleGroupImageLoadError = async (vehicleGroupId: string, imageIdx: number, key?: string) => {
    if (!key) return;
    const retryId = `${vehicleGroupId}-${imageIdx}`;
    if (retriedGroupImagesRef.current.has(retryId)) return;
    retriedGroupImagesRef.current.add(retryId);

    const freshUrl = await getSignedUrl(key);
    if (!freshUrl) return;

    setVehicleGroupsImage((prev: any[]) =>
      prev.map((vgImg) =>
        vgImg.vehicleGroupId === vehicleGroupId
          ? {
              ...vgImg,
              images: vgImg.images.map((img: any, idx: number) =>
                idx === imageIdx ? { ...img, url: freshUrl } : img
              ),
            }
          : vgImg
      )
    );
  };

  const getMileageLimitText = (mileageLimit: number, rateType: string) => {
    switch (rateType) {
      case "hourly":
        return `${mileageLimit} ${currentBranch?.distanceUnit}s/${t("root:hour")}`;
      case "daily":
        return `${mileageLimit} ${currentBranch?.distanceUnit}s/${t("root:day")}`;
      case "weekly":
        return `${mileageLimit} ${currentBranch?.distanceUnit}s/${t("root:week")}`;
      case "monthly":
        return `${mileageLimit} ${currentBranch?.distanceUnit}s/${t("root:month")}`;
    }
  }

  const getMileageDetailsTooltipContent = (basePrices: IRate[], distanceUnit: string) => {
    const currentBookingPrice = basePrices.find(price => price.rateTypeName === values.rateTypeName);
    return (
      <React.Fragment>
        <Typography color="inherit">{t("root:pricePerExtraMile")}: {toCurrency(currentBookingPrice?.pricePerExtraMile || 0, currency, locale)} per {distanceUnit}</Typography>
      </React.Fragment>
    );
  };

  const taxes = currentBranch && currentBranch.addTaxOptIn ? currentBranch.taxes.map((tax) => {
    return {
      code: tax.title,
      type: tax.type,
      rate: tax.rate,
      amount: tax.value,
      isVehicleGroupSpecific: tax.isVehicleGroupSpecific || false,
      vehicleGroups: tax.vehicleGroups || [],
      subdivisionOptIn: tax.subdivisionOptIn,
      subdivisionRate: tax.subdivisionRate,
      subdivisionType: tax.subdivisionType,
      subdivisionValue: tax.subdivisionValue
    }
  }) : [];

  const taxHasValue = () => {
    const taxAmount = getRetnalTaxAmount(taxes, 100, values.rateTypeDuration, 1);
    return Boolean(taxAmount);
  }

  const handleImageClick = (index: number, vehicleImages: VehicleImages[]): void => {
    setSelectedImageIndex(index);
    setIsModalOpen(true);
    setVehicleImages(vehicleImages)
  };

  const handleClose = (): void => {
    setIsModalOpen(false);
    setSelectedImageIndex(null);
    setVehicleImages([]);
  };

  const renderVehicleGroups = (smartCarOnly: boolean) => {
    if (!renderedVehicleGroups.length) {
      return (
        <div className={styles.vehicleGroupcard} style={{ padding: 15, border: 0 }}>
          {t("root:noGroupFound")}
        </div>
      );
    }

    let hasVehicleWithNonZeroPrice = false;

    const renderArray = renderedVehicleGroups.map((item: IRenderedVehicleGroup) => {
      if (!item.vehicles.length) return null;
      const isContactlessVehicle = (vehicle: IVehicleSelection) => (
        vehicle.isCarShare ||
        isRemoteLockVehicle(vehicle) ||
        vehicle.isContactless
      );

      const allContactless = item.vehicles.every(isContactlessVehicle);
      const someContactless = item.vehicles.some(isContactlessVehicle);

      const mixedContactlessGroup = someContactless && !allContactless;
      const basePrice = item.basePrices?.find(
        (price: IRate) => price.rateTypeName === values.rateTypeName
      );
      let isPriceZero = false;

      if (basePrice) {
        if (basePrice.hasOwnProperty("applicableAmount") && typeof basePrice.applicableAmount === "number") {
          if (basePrice.applicableAmount === 0) {
            isPriceZero = true;
          }
        } else {
          if (basePrice.rate === 0) {
            isPriceZero = true;
          }
        }
      }

      vehicleGroupsImage.forEach((vgImg: any) => {
        if (vgImg.vehicleGroupId === item.id) item.images = vgImg.images;
      });

      if (item.vehicles.length && !isPriceZero) {
        hasVehicleWithNonZeroPrice = true;

        return (
          <Grid key={item.id} item xs={12} sm={6} md={6} className={classes.groupGridItem}>
            <div className={classes.vehicleGroupCardPremium}>
              {/* Top area: image (click opens gallery), name, price and features */}
              <div className={classes.cardTopVertical}>
                <div className={classes.imageContainerFix}
                  onClick={() => {
                    if (item?.images?.length === 1) {
                      handleImageClick(0, item?.images)
                    } else if (item?.images?.length > 1) {
                      handleImageClick(0, item?.images)
                    }
                  }}
                >
                  {item?.images?.length > 1 ? (
                    <Slider {...settings}>
                      {item?.images.map((image, index) => (
                        <img
                          key={index}
                          src={image.url}
                          alt='vehicle'
                          onError={() => handleGroupImageLoadError(item.id, index, image.key)}
                        />
                      ))}
                    </Slider>
                  ) : item?.images?.length === 1 ? (
                    <img
                      src={item.images[0].url}
                      alt='vehicle'
                      onError={() => handleGroupImageLoadError(item.id, 0, item.images[0].key)}
                    />
                  ) : (
                    <img
                      src={require("../../../../assets/icons/vehicle-group.svg").default}
                      alt={t("root:gropu1Icon")}
                      className={classes.noImage}
                    />
                  )}
                </div>

                <div className={classes.infoBlockVertical}>
                  <div className={classes.titleRow}>
                    <div className={classes.titleLeft}>
                      <Typography className={classes.groupTitle} noWrap>{item.name}</Typography>
                    </div>
                    {showVehicleGroupPrices && (
                      <div className={classes.titleRight}>
                        <div className={classes.priceAndBadgesRow}>
                          {renderGroupBasePrice(item)}
                          <span className={classes.taxLabel}>
                            {taxHasValue() &&
                              (website.vatInclusivePricingEnabled ? "VAT Inc." : `+ ${country === "United States" ? t("root:taxFees") : "VAT"}`)}
                          </span>
                          <Tooltip
                            enterTouchDelay={0}
                            leaveTouchDelay={3000}
                            arrow
                            placement="top"
                            title={
                              <>
                                <p>{` ${t("root:rental")} (1 x ${toCurrency(rentalPrice, currency, locale)}) = ${toCurrency(rentalPrice, currency, locale)}`}</p>
                                {website.vatInclusivePricingEnabled && (
                                  <p>{`${t("root:vatTax")} = ${toCurrency(renderTaxPrice(item), currency, locale)}`}</p>
                                )}
                              </>
                            }
                          >
                            <IconButton size="small" aria-label="info" className={classes.infoBtn}>
                              <InfoIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </div>
                      </div>
                    )}
                  </div>

                  {
                    showVehicleGroupPrices && (
                      <div className={classes.titleRow}>
                        <div className={classes.titleLeft}>
                          {bookingCategorySettings.showMileage &&
                            <div className={styles.vehicleFeature}>
                              {basePrice && (
                                <span className={styles.vehicleFeatureContent} style={{ display: "flex", alignItems: "center", gap: 4 }}>
                                  <img
                                    src={require("../../../../assets/icons/speedometer.png").default}
                                    alt={t("root:speedometer")}
                                    className={classes.featureIcon}
                                  />
                                  {basePrice.unlimitedMileage ? (
                                    <span >{t("root:unlimited")}</span>
                                  ) : (
                                    <Tooltip
                                      enterTouchDelay={0}
                                      leaveTouchDelay={3000}
                                      placement="top"
                                      arrow
                                      title={getMileageDetailsTooltipContent(item.basePrices, currentBranch?.distanceUnit || 'mile')}
                                    >
                                      <span style={{ cursor: 'pointer', textDecoration: 'underline' }}>
                                        {basePrice.mileageLimit > 0 && getMileageLimitText(basePrice.mileageLimit, basePrice.rateTypeName)}
                                      </span>
                                    </Tooltip>
                                  )}
                                </span>
                              )}
                            </div>
                          }
                        </div>
                        <div className={classes.titleRight}>
                          {[RATE_TYPES.HOURLY, RATE_TYPES.DAILY].includes(basePrice?.rateTypeName as RATE_TYPES) && (() => {
                            const unitPrice = basePrice?.applicableAmount ?? basePrice?.rate ?? 0;
                            const taxAmount = renderTaxPrice(item);
                            const priceWithTax = unitPrice + taxAmount;
                            const unitPriceForTotal = website.vatInclusivePricingEnabled ? priceWithTax : unitPrice;
                            const duration = basePrice?.rateTypeName === RATE_TYPES.HOURLY
                              ? Math.max(1, Math.ceil(bookingDurationInHours))
                              : Math.max(1, Math.ceil(bookingDurationInDays));
                            const total = unitPriceForTotal * duration;
                            return (
                              <Typography style={{ fontSize: 18, fontWeight: 600, color: "#111827" }}>
                                {t("root:total")}: {toCurrency(total, currency, locale)}
                              </Typography>
                            );
                          })()}
                        </div>
                      </div>
                    )
                  }
                </div>
                <div className={classes.infoBlockVertical}>
                  <div className={classes.featuresRow}>
                    <span className={classes.specPill}>{getDoorString(item)}</span>
                    <span className={classes.specPill}>{getSeatString(item)}</span>
                    <span className={classes.specPill}>{getTransmissionString(item)}</span>
                    <span className={classes.specPill}>{getFuelTypeString(item)}</span>
                  </div>
                  <div style={{ width: "100%", marginTop: 8 }}>
                    <NuvvenDivider noMargin />
                  </div>
                  <div className={classes.actionsRow}>
                    {
                      vehicleDetailsSettings?.showVehicleOnGroup && (
                        <div className={classes.counterWrap}>
                          <Tooltip title={"View Vehicles"} arrow interactive>
                            <IconButton
                              className={classes.viewIconBtn}
                              onClick={() => {
                                setOpenGroup(item);
                                setSelectedVehicle(item.vehicles[0]);
                                renderGroupBasePrice(item, true);
                              }}
                            >
                              <ExpandMoreIcon className={classes.arrowIcon} />
                            </IconButton>
                          </Tooltip>
                        </div>
                      )
                    }
                    <div className={classes.counterWrap}>
                      <VehicleCounter
                        count={item.selectedCount || 0}
                        maxCount={smartCarOnly || !multipleVehicleBooking ? 1 : item.vehicles.length}
                        vehicleGroup={item}
                        multipleVehicleBooking={multipleVehicleBooking}
                        updateCounter={updateVehicleSelection}
                        allContactlessGroup={allContactless}
                        mixedContactlessGroup = {mixedContactlessGroup}
                        smartCarOnly={smartCarOnly}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Grid>
        );
      }

      return null;
    });

    if (!hasVehicleWithNonZeroPrice) {
      return (
        <div className={styles.vehicleGroupcard} style={{ padding: 15, border: 0 }}>
          {t("root:noGroupFound")}
        </div>
      );
    }

    return renderArray;
  };


  const updateVehicleSelection = (focusedGroup: IVehiclePriceGroup, isIncrease: boolean, vehicleId?: string, smartCarOnly?: boolean) => {
    let limitVehicleSelection: boolean = smartCarOnly || bookingCategorySettings.maxVehiclesAllowed === 1 || !multipleVehicleBooking || false;
    const vehicleGroupIndex = renderedVehicleGroups.findIndex((vg) => vg.id === focusedGroup.id);
    const vehicleGroup: IRenderedVehicleGroup = renderedVehicleGroups[vehicleGroupIndex];
    let tempGroupArray = [...renderedVehicleGroups];
    if (limitVehicleSelection && isIncrease) {
      for (let i = 0; i < tempGroupArray.length; i++) {
        tempGroupArray[i].selectedCount = 0;
        for (const vehicle of tempGroupArray[i].vehicles) {
          vehicle.selected = false;
        }
      }
    }
    const tempVehiclesArray = tempGroupArray[vehicleGroupIndex].vehicles;
    const count = vehicleGroup.selectedCount || 0;
    let bookingVehicleGroups: IBookingVehicleGroup[] = limitVehicleSelection && isIncrease ? [] : [...values.vehicleGroups];
    let checkCount = limitVehicleSelection ? 1 : vehicleGroup.vehicles.length;
    if (isIncrease) {
      if (count < checkCount) {
        let selectedVehicleId: string = '';
        for (var i = 0; i < tempVehiclesArray.length; i++) {
          if ((vehicleId && tempVehiclesArray[i].id === vehicleId) || (!vehicleId && !tempVehiclesArray[i].selected)) {
            if (vehicleId) {

              tempGroupArray[vehicleGroupIndex].vehicles[i].selected = true;
              selectedVehicleId = tempVehiclesArray[i].id as string;
            }
            const basePrice = tempGroupArray[vehicleGroupIndex].basePrices.find(
              (item) => item.rateTypeName === values.rateTypeName
            );
            let bookingVG = bookingVehicleGroups.find(vg => vg.vehicleGroup === tempGroupArray[vehicleGroupIndex].id)

            if (bookingVG && bookingVG?.protectionPlans) {
              props.setSelectedProtectionVehicleGroupPlan(bookingVG.protectionPlans)
            }

            if (!bookingVG) {
              if (basePrice) {
                bookingVehicleGroups.push({
                  baseRate: basePrice.rate || 0,
                  count: 1,
                  deposit: tempGroupArray[vehicleGroupIndex].deposit,
                  mileageLimit: basePrice.mileageLimit || 0,
                  pricePerExtraMile: basePrice.pricePerExtraMile || 0,
                  ...(basePrice.priceRule && { priceRule: basePrice.priceRule }),
                  ...(basePrice.priceRuleAmount && { priceRuleAmount: basePrice.priceRuleAmount }),
                  ...(basePrice.priceRuleName && { priceRuleName: basePrice.priceRuleName }),
                  ...(basePrice.priceRuleOperator && { priceRuleOperator: basePrice.priceRuleOperator }),
                  ...(basePrice.priceRuleValueType && { priceRuleValueType: basePrice.priceRuleValueType }),
                  ...(basePrice.priceRuleTriggerType && { priceRuleTriggerType: basePrice.priceRuleTriggerType }),
                  unlimitedMileage: basePrice.unlimitedMileage ? basePrice.unlimitedMileage : false,
                  vehicleGroup: tempGroupArray[vehicleGroupIndex].id as string,
                  name: tempGroupArray[vehicleGroupIndex].name,
                  vehicleIds: vehicleId ? [selectedVehicleId] : [],
                  riskBasedPricingApplied: basePrice.riskBasedPricingApplied || false,
                  riskBasedPricingAmount: basePrice.riskBasedPricingAmount || 0,
                  // vehicleIds: [selectedVehicleId],
                });
              }
            } else {
              if (vehicleId && !bookingVG.vehicleIds.includes(selectedVehicleId)) {
                bookingVG.vehicleIds.push(selectedVehicleId);
              }
              bookingVG.count += 1;
              // if (!bookingVG.vehicleIds.some(item => item === selectedVehicleId)) {
              //   bookingVG.vehicleIds.push(selectedVehicleId);
              //   bookingVG.count += 1;
              // }
            }
            break;
          }
        }
        tempGroupArray.map((vg, index) => {
          if (index !== vehicleGroupIndex) {
            vg.vehicles = vg.vehicles.filter(vehicle => vehicle?.id !== selectedVehicleId);
          }
        });
        tempGroupArray[vehicleGroupIndex].selectedCount = count + 1;
      }
    } else {
      if (count > 0) {
        let unselectedVehicleId: string = '';
        const bookingVGIndex = bookingVehicleGroups.findIndex(vg => vg.vehicleGroup === tempGroupArray[vehicleGroupIndex].id);
        for (var i = tempVehiclesArray.length - 1; i >= 0; i--) {
          if ((!vehicleId && tempVehiclesArray[i].selected) || (vehicleId && tempVehiclesArray[i].id === vehicleId)) {
            tempGroupArray[vehicleGroupIndex].vehicles[i].selected = false;
            unselectedVehicleId = tempVehiclesArray[i].id as string;
            if (vehicleId) {
              bookingVehicleGroups[bookingVGIndex].vehicleIds = bookingVehicleGroups[bookingVGIndex].vehicleIds.filter(
                id => id !== unselectedVehicleId
              );
            } else {
              bookingVehicleGroups[bookingVGIndex].vehicleIds.pop();
            }
            // bookingVehicleGroups[bookingVGIndex].vehicleIds = bookingVehicleGroups[bookingVGIndex].vehicleIds.filter(id => id !== unselectedVehicleId);
            // bookingVehicleGroups[bookingVGIndex].count -= 1;
            // if (!bookingVehicleGroups[bookingVGIndex].vehicleIds.length) {
            //   bookingVehicleGroups.splice(bookingVGIndex, 1);
            // }
            break;
          }
        }
        renderedVehicleGroups.map((vg: any, groupIndex) => {
          let tempVehicleArray: IVehicleSelection[] = [];
          if (groupIndex !== vehicleGroupIndex) {
            vg.vehicles?.map((vehicle: any) => {
              const vehicleIndex = tempGroupArray[groupIndex].vehicles.findIndex(item => item.id === vehicle.id)
              if (vehicleIndex >= 0) {
                tempVehicleArray.push(tempGroupArray[groupIndex].vehicles[vehicleIndex]);
              }
              if ((vehicle.id === unselectedVehicleId)) {
                tempVehicleArray.push({ ...vehicle, selected: false })
              }
            });
            tempGroupArray[groupIndex].vehicles = tempVehicleArray
          }
        });
        tempGroupArray[vehicleGroupIndex].selectedCount = count - 1;
        bookingVehicleGroups[bookingVGIndex].count -= 1;
        if (bookingVehicleGroups[bookingVGIndex].count === 0) {
          bookingVehicleGroups.splice(bookingVGIndex, 1);
        }
      }
    }
    setRenderedVehicleGroups(tempGroupArray);

    let isCarShare = false;
    let smartCarVehicle = false;
    if (smartCarOnly && bookingVehicleGroups.length) {
      setSmartCarOnly(true);
      const selectedVehicleGroupId = bookingVehicleGroups[0].vehicleGroup
      const selectedVehicleId = bookingVehicleGroups[0].vehicleIds[0]

      const selectedVehicle = renderedVehicleGroups?.find(
        vg => vg.id === selectedVehicleGroupId
      )?.vehicles.find(
        vehicle => vehicle.id === selectedVehicleId
      )

      // Remote lock flag follows the selected vehicle (Smartcar, or Volteras / Teltonika with keyless support)
      smartCarVehicle = isRemoteLockVehicle(selectedVehicle);

      if (selectedVehicle?.isCarShare && organisation.allowCarSharing) {
        isCarShare = true
      }
    } else{
      setSmartCarOnly(false);
    }
    const { isSubscription, activeSubscription, activeSubscriptionExpanded, ...rest } = values
    let bookingVGs = bookingVehicleGroups
    if (bookingVGs) {
      let tempVehicleGroupProtectionPlan: IVehicleGroupProtectionPlan[][] = [];

      for (let i = 0; i < bookingVGs.length; i++) {
        let protectionPlans = renderedVehicleGroups.find((vg) => vg.id === bookingVGs[i].vehicleGroup)?.protectionPlans;
        if (protectionPlans) {
          let updatedProtectionPlan = protectionPlans.map((plan: IVehicleGroupProtectionPlan) => {
            let updatedRecurringRate: IAddonRate[] = [];
            let updatedFixRate = 0;

            if (plan.hasFixedRate) {
              updatedFixRate = plan.fixedRate! * bookingVGs[i].count;
            }

            if (plan.recurringRate) {
              updatedRecurringRate = plan.recurringRate.map((recurringRateObj: IAddonRate) => {
                let newRate = recurringRateObj.rate * bookingVGs[i].count;
                return {
                  ...recurringRateObj,
                  rate: newRate
                };
              });
            }

            return {
              ...plan,
              fixedRate: plan.hasFixedRate ? updatedFixRate : 0,
              recurringRate: plan.recurringRate ? updatedRecurringRate : []
            };
          });

          tempVehicleGroupProtectionPlan.push(updatedProtectionPlan);
        }
      }
      // Flatten the array
      let flattenedTempVehicleGroupProtectionPlan = tempVehicleGroupProtectionPlan.flat();
      let vehicleGroupProtectionPlans: IVehicleGroupProtectionPlan[] = [];

      flattenedTempVehicleGroupProtectionPlan.forEach((protectionPlan: IVehicleGroupProtectionPlan) => {
        let existingProtectionPlanIndex = vehicleGroupProtectionPlans.findIndex(
          (p) => p.plan.id === protectionPlan.plan.id
        );
        if (existingProtectionPlanIndex === -1) {
          vehicleGroupProtectionPlans.push(protectionPlan);
          return;
        } else {
          let existingProtectionPlan = vehicleGroupProtectionPlans[existingProtectionPlanIndex];
          let updatedFixedRate = 0;
          let updatedRecurringRate: IAddonRate[] = [];

          if (protectionPlan.hasFixedRate || existingProtectionPlan.hasFixedRate) {
            if (protectionPlan.hasFixedRate && existingProtectionPlan.hasFixedRate) {
              updatedFixedRate = existingProtectionPlan.fixedRate! + protectionPlan.fixedRate!;
            } else {
              updatedFixedRate = protectionPlan.fixedRate! || existingProtectionPlan.fixedRate!;
            }
          }

          if (protectionPlan.recurringRate || existingProtectionPlan.recurringRate) {
            if (protectionPlan.recurringRate && existingProtectionPlan.recurringRate) {
              let mergedRecurringRates: IAddonRate[] = [];

              protectionPlan.recurringRate.forEach((rate) => {
                let existingRate = existingProtectionPlan.recurringRate!.find(
                  (r) => r.rateTypeName === rate.rateTypeName
                );

                if (existingRate) {
                  mergedRecurringRates.push({
                    ...rate,
                    rate: existingRate.rate + rate.rate
                  });
                } else {
                  mergedRecurringRates.push(rate);
                }
              });

              updatedRecurringRate = mergedRecurringRates;
            } else {
              updatedRecurringRate = protectionPlan.recurringRate! || existingProtectionPlan.recurringRate!;
            }
          }

          vehicleGroupProtectionPlans[existingProtectionPlanIndex] = {
            ...existingProtectionPlan,
            fixedRate: updatedFixedRate,
            recurringRate: updatedRecurringRate
          };
        }
      });
      props.setSelectedProtectionVehicleGroupPlan(vehicleGroupProtectionPlans)
    }
    else {
      props.setSelectedProtectionVehicleGroupPlan([])
    }
    for (const bookingVehicleGroup of bookingVehicleGroups) {
      const vg = renderedVehicleGroups.find(vg => vg.id === bookingVehicleGroup.vehicleGroup)
      if (vg) {
        bookingVehicleGroup.availableVehicleIds = [...vg.vehicles, ...(vg.sharedVehicles || [])].map(v => v.id!)
      }
    }
    setValues({
      ...rest,
      locationSurcharges: locationSurchargeData,
      vehicleGroups: bookingVehicleGroups,
      isCarShare: isIncrease ? isCarShare : false,
      smartCarVehicle: isIncrease ? smartCarVehicle : false,
      isKeylessEntry: smartCarOnly,
    });
    setFleetType(vehicleGroup.fleetType || "");
  }

  const showSummary = () => {
    let selectedVehiclesCount = 0;
    if (values.isSubscription) {
      selectedVehiclesCount = 1;
    } else {
      values.vehicleGroups.forEach((group) => {
        selectedVehiclesCount += group.count;
        // selectedVehiclesCount += group.vehicleIds.length;
      })
    }
    return !isTestDrive && selectedVehiclesCount > 0;
  }

  const handleFilterUpdate = (filters: { [key: string]: string[] }) => {
    setSearchFilters({
      ...searchFilters,
      ...filters
    });
  };

  const onSelectSubscription = (selectedSubscription: ISubscriptionArgs, vehicle: IVehicle) => {
    // const booking = { ...values }
    // if (booking.insuranceName || booking.addonRequirements) {
    //   booking.insuranceName = ""
    //   booking.insurancePolicy = ""
    //   booking.insuranceRate = 0
    //   booking.addonRequirements = []
    // }
    // if (selectedSubscription && selectedSubscription.subscription) {
    //   const weeklySubscription = selectedSubscription.subscription.rateTypeName === RATE_TYPES.WEEKLY ? true : false
    //   const activeSubscription = {
    //     duration: selectedSubscription.pricing.duration,
    //     endDate: props.bookingData.dropoffDateTime || "",
    //     enrollmentAmount: selectedSubscription.pricing.enrollmentAmount,
    //     subscriptionAmount: selectedSubscription.pricing.subscriptionAmount,
    //     startDate: props.bookingData.pickupDateTime,
    //     subscription: selectedSubscription.subscription.id,
    //     vehicle: vehicle?.id || "",
    //     unlimitedMileage: selectedSubscription.pricing.unlimitedMileage,
    //     mileageLimit: selectedSubscription.pricing.mileage,
    //     pricePerExtraMile: selectedSubscription.pricing.pricePerExtraMile,
    //     swapsAllowed: selectedSubscription.pricing.swapsAllowed,
    //     deposit: selectedSubscription.deposit
    //   }
    //   setActiveSubscriptionData({
    //     ...activeSubscription,
    //     subscription: selectedSubscription.subscription,
    //     vehicle: vehicle
    //   })
    //   setValues({
    //     ...booking,
    //     vehicleGroups: [],
    //     isSubscription: true,
    //     activeSubscription,
    //     billingCycleDuration: weeklySubscription ? 10080 : 43200,
    //     billingCycleName: weeklySubscription ? RATE_TYPES.WEEKLY : RATE_TYPES.MONTHLY,
    //     rateTypeDuration: weeklySubscription ? 10080 : 43200,
    //     rateTypeName: weeklySubscription ? RATE_TYPES.WEEKLY : RATE_TYPES.MONTHLY,
    //     activeSubscriptionExpanded: {
    //       ...activeSubscription,
    //       subscription: selectedSubscription.subscription,
    //       vehicle: vehicle
    //     },
    //     locationSurcharges: [],
    //     defaultBillingCycle: false
    //   })
    // }
  }

  const removeSubscription = () => {
    setValues({
      ...values,
      isSubscription: false,
      vehicleGroups: [],
      insuranceName: "",
      insurancePolicy: "",
      insuranceRate: 0,
      addonRequirements: [],
      defaultBillingCycle: true
    })
  }

  const clearFilters = () => {
    setSearchFilters(initialFilters)
  }

  const showGridForSubscription: boolean = props.bookingType === BookingType.SUBSCRIPTION && !showSummary()

  return (
    <div className={styles.searchResult}>
      {
        <Grid container spacing={2}>
          {!showSummary() && !hideFilters && (
            <Hidden smDown>
              {
                props.bookingType !== BookingType.SUBSCRIPTION && (
                  <Grid item xs={12} md={2} style={{ marginTop: "3rem" }}>
                    <FiltersView
                      filters={filters}
                      onChange={handleFilterUpdate}
                    />
                  </Grid>
                )
              }
            </Hidden>
          )}
          <Grid item xs={12} md={showGridForSubscription ? 12 : !showSummary() ? 10 : 8} lg={showGridForSubscription ? 12 : !showSummary() ? 10 : 9} container className={classes.renderVehicleGrid}>
            <Grid item xs={12} container spacing={2} style={{ margin: "0 auto" }}>
              <Grid container item xs={12} alignItems='center'>
                <Typography variant="h4" style={{ fontWeight: 700 }} >{t("root:searchResults")}</Typography>
                {
                  !organisation.closeGroupSharingEnabled && bookingCategorySettings.showFilters &&
                  <div className="flex fill main-end cross-center">
                    {!hideFilters && (
                      <Hidden mdUp>
                        <div className={styles.sortButton} onClick={() => setOpenFilterBottomSheet(!openFilterBottomSheet)}>
                          <FilterListIcon fontSize='small' />
                          <Typography variant="h4" style={{ fontWeight: 700, marginRight: 5, marginLeft: 5 }} >Filter</Typography>
                        </div>
                      </Hidden>
                    )} 

                    {
                      bookingCategorySettings.showPriceSort && (
                        <div className={styles.sortAction}>
                          <div className={styles.sortButton}>
                            <ImportExportIcon fontSize="small" />
                            <Typography variant="h4" style={{ fontWeight: 700 }} >{t("root:sort")}</Typography>
                          </div>
                          <div className={styles.sortOptions}>
                            <p onClick={() => setSortOrder(0)}>{t("root:priceLowToHigh")}</p>
                            <p onClick={() => setSortOrder(1)}> {t("root:priceHighToLow")}</p>
                          </div>
                        </div>
                      )
                    }
                  </div>
                }
              </Grid>
              {/* {
                bookingCategorySettings.showKeylessVehiclesToggle && hasSmartCar && showSmartCarFilter && <Grid item xs={12} md={12} style={{ marginBottom: 20 }}>
                  <div style={{ background: "#fff", borderRadius: 6, padding: "10px 20px" }}>
                    <Typography variant="subtitle1" style={{ fontWeight: 700 }}>{t("root:weHaveSmartCars")}</Typography>
                    <Typography variant="body1" style={{ borderBottom: "1px solid #e2e2e2", paddingBottom: 10, color: "#848484" }}>{t("root:keylessSupport")}</Typography>
                    <div className="flex space-between padding-top">
                      <Typography variant="body1">{t("root:keylessVehicles")}</Typography>
                      <AntSwitch checked={smartCarOnly} onChange={() => setSmartCarOnly(prev => !prev)} />
                    </div>
                  </div>
                </Grid>
              } */}

              {
                values.isSubscription && activeSubscriptionData && (
                  <Grid container item sm={12}>
                    <Grid item xs={12}>
                      <Card component={Paper} elevation={0} className={styles.subscriptionCarMain}>
                        <CardContent>
                          <Grid item xs={12} container spacing={2} alignItems='center'>
                            <Grid item xs={3}>
                              {activeSubscriptionData.vehicle?.imageUrl ? (
                                <img
                                  className="fleet-resrc-img"
                                  alt={t("root:vehicleTypeIcon")}
                                  src={activeSubscriptionData.vehicle.imageUrl}
                                  height="90"
                                  width="180"
                                />
                              ) : (
                                <img
                                  className="fleet-resrc-img"
                                  alt={t("root:vehicleTypeIcon")}
                                  src={getVehicleTypeIcon(
                                    capitalizeFirstLetter(activeSubscriptionData.vehicle?.bodyType || "")
                                  )}
                                />
                              )}
                            </Grid>
                            <Grid item xs={9} container>
                              <Grid item xs={12}><Typography gutterBottom style={{ fontSize: 16, textTransform: "uppercase", fontWeight: 600, marginBottom: 10 }} variant="h3">{activeSubscriptionData.subscription?.name}</Typography></Grid>
                              <Grid item xs={4}>
                                <Typography gutterBottom variant="h4">{t("root:startDate")}: <span style={{ fontSize: 14, fontWeight: 300 }}>{dayjs(activeSubscriptionData.startDate).tz().format("DD/MM/YYYY")}</span> </Typography>
                                <Typography gutterBottom variant="h4">{t("root:endDate")} : <span style={{ fontSize: 14, fontWeight: 300 }}>{dayjs(activeSubscriptionData.endDate).tz().format("DD/MM/YYYY")}</span> </Typography>
                                <Typography gutterBottom variant="h4">{t("root:duration")} : <span style={{ fontSize: 14, fontWeight: 300 }}>{`0${activeSubscriptionData.duration} ${activeSubscriptionData.subscription?.rateTypeName === RATE_TYPES.WEEKLY ? t("root:weeks") : t("root:months")}(${t("root:min")})`}</span></Typography>
                                <Typography gutterBottom variant="h4">{t("root:swapsAllowed")} : <span style={{ fontSize: 14, fontWeight: 300 }}>{activeSubscriptionData.swapsAllowed || t("root:na")}</span> </Typography>
                              </Grid>
                              <Grid item xs={4}>
                                <Typography gutterBottom variant="h4">{t("root:enrollmentAmount")}: <span style={{ fontSize: 14, fontWeight: 300 }}>{toCurrency(activeSubscriptionData.enrollmentAmount || 0, currency, locale)}</span> </Typography>
                                <Typography gutterBottom variant="h4">{t("root:subscriptionAmount")}: <span style={{ fontSize: 14, fontWeight: 300 }}>{toCurrency(activeSubscriptionData.subscriptionAmount || 0, currency, locale)}</span> </Typography>
                                <Typography gutterBottom variant="h4">{t("root:mileageLimit")}: <span style={{ fontSize: 14, fontWeight: 300 }}>{activeSubscriptionData.unlimitedMileage ? t("root:unlimited") : activeSubscriptionData.mileageLimit}</span> </Typography>
                              </Grid>
                              <Grid item xs={4}>
                                {
                                  activeSubscriptionData.unlimitedMileage ?
                                    <Typography gutterBottom variant="h4"> {t("root:pricePerExtraMile")} : <span style={{ fontSize: 14, fontWeight: 300 }}>{t("root:na")}</span></Typography>
                                    :
                                    <Typography gutterBottom variant="h4">{t("root:pricePerExtraMile")}: <span style={{ fontSize: 14, fontWeight: 300 }}>{toCurrency(activeSubscriptionData.pricePerExtraMile || 0, currency, locale)}</span></Typography>
                                }
                                <Typography gutterBottom variant="h4">{t("root:insurancePolicy")}: <span style={{ fontSize: 14, fontWeight: 300 }}>{activeSubscriptionData.subscription?.insurancePolicy?.name || "-"}</span>
                                </Typography>
                                <Typography gutterBottom variant="h4">{t("root:addons")}: <span style={{ fontSize: 14, fontWeight: 300 }}>{activeSubscriptionData.subscription?.addons?.map(addon => addon.displayName).join(", ") || "-"}</span>
                                </Typography>

                              </Grid>
                            </Grid>
                          </Grid>
                        </CardContent>
                        <CardActions>
                          <Grid item xs={12} container justify="flex-end">
                            <Button
                              onClick={() => removeSubscription()}
                            >{t("root:removeSubscription")}</Button>
                          </Grid>
                        </CardActions>
                      </Card>
                    </Grid>
                  </Grid>
                )
              }

              <Grid xs={12} container className={values.isSubscription ? styles.disableRentals : ""} >
                {
                  (props.bookingType === BookingType.SUBSCRIPTION) ?
                    renderedSubscriptionVehicles?.length ? (
                      <SelectSubscriptionVehicleView
                        subscriptionVehicles={renderedSubscriptionVehicles}
                        bookingDurationInMonths={bookingDurationInMonths}
                        showGridForSubscription={showGridForSubscription}
                        bookingDurationInWeeks={bookingDurationInWeeks}
                        onSelectSubscription={onSelectSubscription}
                      />
                    ) : (
                      <div className={styles.vehicleGroupcard} style={{ padding: 15, border: 0 }}>{t("root:noGroupFound")}</div>
                    ) : ""
                }

                {
                  [BookingType.RENTAL, BookingType.TEST_DRIVE].includes(props.bookingType as BookingType) && (
                    renderVehicleGroups(smartCarOnly)
                  )
                }

              </Grid>
            </Grid>
          </Grid>
          {showSummary() &&
            <Grid item xs={12} sm={12} md={4} lg={3}>
              <SummaryPanel bookingInput={values} oneWayRentalFee={props.oneWayRentalFee ? props.oneWayRentalFee : undefined} />
            </Grid>
          }
          {
            ReactDOM.createPortal(<div className={`${styles.filterBottomSheet} ${openFilterBottomSheet ? styles.activeBottomSheet : ''}`}>
              <FiltersBottomSheet
                filters={filters}
                onChange={handleFilterUpdate}
                onClick={setOpenFilterBottomSheet}
                clearFilters={clearFilters}
              />
            </div>, document.body)
          }
        </Grid>
      }
      <Box pb={10}></Box>
      {vehicleImages.length > 0 && <Modal
        open={isModalOpen}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div className={styles.modalContent}>
          <Slider {...settings} initialSlide={selectedImageIndex as number}>
            {vehicleImages.map((image, index) => (
              <div key={index} className={styles.sliderImageWrapper}>
                <Image imageKey={image.url} />
              </div>
            ))}
          </Slider>
        </div>
      </Modal>}
      {/* GROUP VEHICLE LIST DIALOG — place near root of component render */}
      {
        openGroup && (
          <Drawer
            anchor="right"
            open={Boolean(openGroup)}
            onClose={() => setOpenGroup(null)}
            transitionDuration={400}
            classes={{ paper: classes.drawerPaper }}

          >
            {/* HEADER */}
            <Box className={classes.drawerHeader}>
              <Box className={classes.drawerGroupInfo}>
                <Box className={classes.drawerGroupImage}>
                  {openGroup.images?.[0]?.url ? (
                    <img src={openGroup.images[0].url} alt={openGroup.name} />
                  ) : (
                    <img
                      src={require("../../../../assets/icons/vehicle-group.svg").default}
                      alt={openGroup.name}
                    />
                  )}
                </Box>
                <Box>
                  <Typography style={{ fontWeight: 700, fontSize: 20, color: "#111827" }}>
                    {openGroup.name}
                  </Typography>
                  <Typography style={{ color: "#6b7280", fontSize: 13 }}>
                    {bookingCategorySettings.showVehicleAvailableCount &&
                      `${t("root:available")}: ${openGroup.vehicles.length}`}
                  </Typography>
                </Box>
              </Box>

              <IconButton
                onClick={() => {
                  setSelectedVehicle(null);
                  setOpenGroup(null);
                }}
              >
                <Close />
              </IconButton>
            </Box>

            <Divider />

            <Fade in={mode === "split"} timeout={400} unmountOnExit>
              <Box className={classes.splitLayout}>
                <Hidden smDown>
                  <Box className={classes.leftNav}>
                    {openGroup.vehicles.map((v, idx) => {
                      const isActive = selectedVehicle?.id === v.id;
                      const imgUrl = allVehicleImages.find((vi) => vi.vehicleId === v.id);
                      const vehicleDisplayName = `${v.make || ""} ${v.model || ""}`;
                      return (
                        <Box
                          key={idx}
                          className={`${classes.leftVehicleCard} ${isActive ? classes.leftVehicleActive : ""
                            }`}
                          onClick={() => setSelectedVehicle(v)}
                        >
                          <Box className={classes.leftVehicleImage}>
                            <img
                              src={
                                imgUrl
                                  ? imgUrl.url
                                  : getVehicleTypeIcon(capitalizeFirstLetter(v.bodyType))
                              }
                              alt={vehicleDisplayName}
                            />
                          </Box>
                          <Hidden smDown>
                            <Box className={classes.leftVehicleInfo}>
                              <Typography style={{ fontSize: 14, fontWeight: 600, color: "#111827" }}>
                                {vehicleDisplayName}
                              </Typography>
                              <Typography style={{ fontSize: 12, color: "#6b7280" }}>
                                {v.numberOfSeats} Seats • {v.numberOfDoors} Doors
                              </Typography>
                            </Box>
                          </Hidden>
                        </Box>

                      );
                    })}
                  </Box>
                </Hidden>
                <Hidden smUp>
                  <Box position="relative" style={{ padding: 0 }}>
                    <Box
                      className={`${classes.scrollButton} ${classes.scrollButtonLeft}`}
                      onClick={() => {
                        scrollerRef.current?.scrollBy({ left: -260, behavior: "smooth" });
                      }}
                      aria-hidden
                    >
                      <ChevronLeftIcon style={{ fontSize: 18 }} />
                    </Box>

                    <div ref={scrollerRef as React.Ref<HTMLDivElement>} className={classes.leftNav} >
                      {openGroup.vehicles.map((v, idx) => {
                        const isActive = selectedVehicle?.id === v.id;
                        const imgUrl = allVehicleImages.find((vi) => vi.vehicleId === v.id);
                        const vehicleDisplayName = `${v.make || ""}`;
                        return (
                          <Box
                            key={idx}
                            className={`${classes.leftVehicleCard} ${isActive ? classes.leftVehicleActive : ""
                              }`}
                            onClick={() => setSelectedVehicle(v)}
                          >
                            <Box className={classes.leftVehicleImage}>
                              <img
                                src={
                                  imgUrl
                                    ? imgUrl.url
                                    : getVehicleTypeIcon(capitalizeFirstLetter(v.bodyType))
                                }
                                alt={vehicleDisplayName}
                              />
                            </Box>

                            <Hidden smDown>
                              <Box className={classes.leftVehicleInfo}>
                                <Typography style={{ fontSize: 14, fontWeight: 600, color: "#111827" }}>
                                  {vehicleDisplayName}
                                </Typography>
                                <Typography style={{ fontSize: 12, color: "#6b7280" }}>
                                  {v.numberOfSeats} Seats • {v.numberOfDoors} Doors
                                </Typography>
                              </Box>
                            </Hidden>
                          </Box>
                        );
                      })}
                    </div>

                    <Box
                      className={`${classes.scrollButton} ${classes.scrollButtonRight}`}
                      onClick={() => {
                        scrollerRef.current?.scrollBy({ left: 260, behavior: "smooth" });
                      }}
                      aria-hidden
                    >
                      <ChevronRightIcon style={{ fontSize: 18 }} />
                    </Box>
                  </Box>
                </Hidden>

                <Box className={classes.rightDetailPane}>
                  {selectedVehicle && (
                    <VehicleDetailDrawerContent
                      vehicle={selectedVehicle}
                      images={allVehicleImages}
                      vehicleGroup={openGroup}
                      onSelectVehicle={updateVehicleSelection}
                      totalPrice={totalPrice}
                      values={values}
                      showVehicleGroupPrices={showVehicleGroupPrices}
                      smartCarOnly={smartCarOnly}
                    />
                  )}
                </Box>
              </Box>
            </Fade>
          </Drawer>
        )
      }

    </div >
  );
};

export default VehicleSelection;
